export enum ExampleProject {
  Mnist,
  CElegans,
  HumanU2OSCells,
  BBBC013,
}
